module.exports = __webpack_public_path__ + "static/media/pic-st3.6e5f03cc.jpg";